import { render, staticRenderFns } from "./Referrals.vue?vue&type=template&id=997c5fe0"
import script from "./Referrals.vue?vue&type=script&lang=js"
export * from "./Referrals.vue?vue&type=script&lang=js"
import style0 from "./Referrals.vue?vue&type=style&index=0&id=997c5fe0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports